import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "doctor-details-container" }
const _hoisted_2 = { class: "doctor-image-section" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "details-frame" }
const _hoisted_6 = { class: "doctor-info" }
const _hoisted_7 = { class: "doctor-name" }
const _hoisted_8 = { class: "doctor-specialty" }
const _hoisted_9 = { class: "about-section" }
const _hoisted_10 = { class: "d-grid px-2 py-3 py-md-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "back-button ps-4",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "pi pi-chevron-left" }, null, -1)
        ]))
      ]),
      _createElementVNode("img", {
        src: _ctx.doctor.image,
        alt: "Doctor Image",
        class: "doctor-image"
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.doctor.name), 1),
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.doctor.specialty), 1),
        _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"doctor-rating\" data-v-621942d1><i class=\"pi pi-star-fill\" data-v-621942d1></i><i class=\"pi pi-star-fill\" data-v-621942d1></i><i class=\"pi pi-star-fill\" data-v-621942d1></i><i class=\"pi pi-star-fill\" data-v-621942d1></i><i class=\"pi pi-star-fill\" data-v-621942d1></i><span class=\"review-count\" data-v-621942d1>(2344 отзывов)</span></div>", 1))
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { style: {"border-bottom":"1px solid #e0e0e0"} }, null, -1)),
      _createElementVNode("div", _hoisted_9, [
        _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Информация о враче", -1)),
        _createElementVNode("p", null, _toDisplayString(_ctx.doctor.description), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_Button, {
          label: "Записаться на прием",
          severity: "success",
          rounded: "",
          raised: "",
          onClick: _ctx.showDialog
        }, null, 8, ["onClick"])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.dialogVisible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      modal: "",
      showHeader: false,
      style: { width: '300px', borderRadius: '8px' },
      pt: {
        root: { class: 'text-center success-dialog' },
        content: { class: 'text-center p-4' },
      }
    }, {
      default: _withCtx(() => [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "success-icon mb-3" }, [
          _createElementVNode("i", { class: "pi pi-check" })
        ], -1)),
        _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "mb-2" }, "Спасибо!", -1)),
        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-secondary mb-4" }, "Ваша заявка на запись к врачу принята.", -1)),
        _createVNode(_component_Button, {
          label: "OK",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = false)),
          severity: "success",
          rounded: "",
          style: {"width":"100%"}
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}